import React, { useCallback, useEffect, useState } from "react";
import CmGap from "../Components/CmGap";
import MdHeading from "../Components/MdHeading";
import CommonTable from "../Components/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  DatePicker,
  Flex,
  Form,
  Input,
  Modal,
  notification,
  TimePicker,
} from "antd";
import {
  addVisitors,
  editVisitor,
  getAllVisitors,
  getVisitorsExportedData,
  handleNextPagination,
  handlePrevPagination,
} from "../Toolkit/DailyActivitySlice";
import { Icon } from "@iconify/react";
import { Download } from "lucide-react";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
const { RangePicker } = DatePicker;

const Visitors = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const visitorsList = useSelector((state) => state.activity.visitorsList);
  const page = useSelector((state) => state.activity.visitorPage);
  const currentUser = useSelector((state) => state.auth.currentUser.data);
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [exportedData, setExportedData] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  console.log("fdkljhsdlfsdjh", visitorsList);

  useEffect(() => {
    setFilteredData(visitorsList?.visitors);
  }, [visitorsList]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    const filtered = visitorsList?.visitors?.filter((item) =>
      Object.values(item)?.some((val) =>
        String(val)?.toLowerCase()?.includes(value?.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  useEffect(() => {
    if (currentUser) {
      dispatch(getAllVisitors({ email: currentUser?.email, page: page }));
    }
  }, [dispatch, currentUser, page]);

  const handleEditDetails = useCallback(
    (info) => {
      form.setFieldsValue({
        name: info?.name,
        contactNumber: info?.contactNumber,
        visitorMailId: info?.visitorMailId,
        companyName: info?.companyName,
        referenceThrough: info?.referenceThrough,
        purpose: info?.purpose,
      });
      setOpenModal(true);
      setEditData(info);
    },
    [form]
  );

  const handleSubmit = useCallback(
    (values) => {
      let obj = {
        data: values,
        email: currentUser?.email,
      };
      if (editData) {
        obj.id = editData?.id;
        dispatch(editVisitor(obj))
          .then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
              notification.success({ message: "Visitor edited successfully" });
              dispatch(
                getAllVisitors({ email: currentUser?.email, page: page })
              );
              form.resetFields();
              setOpenModal(false);
            } else {
              notification.error({ message: "Something went wrong !." });
            }
          })
          .catch(() => {
            notification.error({ message: "Something went wrong !." });
          });
      } else {
        dispatch(addVisitors(obj))
          .then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
              notification.success({ message: "Visitor added successfully" });
              dispatch(
                getAllVisitors({ email: currentUser?.email, page: page })
              );
              form.resetFields();
              setOpenModal(false);
            } else {
              notification.error({ message: "Something went wrong !." });
            }
          })
          .catch(() => {
            notification.error({ message: "Something went wrong !." });
          });
      }
    },
    [editData, dispatch, currentUser, page]
  );

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Contact no.",
      dataIndex: "contactNumber",
    },
    {
      title: "Visitor's mailId",
      dataIndex: "visitorMailId",
    },
    {
      title: "Company name",
      dataIndex: "companyName",
    },
    {
      title: "In time",
      dataIndex: "inTime",
      render:(data)=>dayjs(data).format('hh:mm A')
    },
    {
      title: "Out time",
      dataIndex: "outTime",
      render:(data)=>dayjs(data).format('hh:mm A')
    },
    {
      title: "Reference",
      dataIndex: "referenceThrough",
    },
    {
      title: "Edit",
      dataIndex: "edit",
      render: (_, record) => (
        <Button
          type="text"
          size="small"
          onClick={() => handleEditDetails(record)}
        >
          <Icon icon="fluent:edit-24-regular" />
        </Button>
      ),
    },
  ];

  const headers = [
    "Id",
    "Name",
    "Email",
    "Date",
    "Login time",
    "Logout time",
    "Company name",
    "Reference by",
    "Purpose",
  ];

  const handleFetchExportData = (values) => {
    let data = {
      fromDate: dayjs(values?.[0]).format("YYYY-MM-DD"),
      toDate: dayjs(values?.[1]).format("YYYY-MM-DD"),
      mailId: currentUser?.email,
    };
    setDateRange(values);
    dispatch(getVisitorsExportedData(data))
      .then((resp) => {
        if (resp.meta.requestStatus === "fulfilled") {
          console.log("sdkjhasdjkgsakj");
          const data = resp?.payload?.visitors;
          const exportData = data?.map((row) => ({
            Id: row?.id,
            Name: row?.name,
            Email: row?.visitorMailId,
            Date: row?.date,
            "Login time": dayjs(row?.inTime).format("hh:mm A"),
            "Logout time": dayjs(row?.outTime).format("hh:mm A"),
            "Company name": row?.companyName,
            "Reference by": row?.referenceThrough,
            Purpose: row?.purpose,
          }));
          setExportedData(exportData);
        } else {
          setExportedData([]);
        }
      })
      .catch(() => setExportedData([]));
  };

  return (
    <CmGap>
      <div className="align-between">
        <MdHeading data={`Visitors list`} />
      </div>
      <Flex justify="space-between" align="center" style={{ marginBottom: 8 }}>
        <Input
          placeholder="Search ..."
          style={{ width: "20%" }}
          value={searchText}
          onChange={handleSearch}
        />
        <Flex gap={8}>
          <RangePicker
            style={{ width: "100%" }}
            value={dateRange}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
            onChange={(e) => handleFetchExportData(e)}
          />
          <CSVLink
            className="text-white"
            data={exportedData}
            headers={headers}
            filename={"visitors_report.csv"}
            onClick={() => {
              if (exportedData.length === 0) return false;
              setTimeout(() => {
                setExportedData([]);
                setDateRange([]);
              }, 500);
            }}
          >
            <Button disabled={exportedData?.length === 0}>
              {" "}
              <Download />
              Download
            </Button>
          </CSVLink>
          <Button type="primary" onClick={() => setOpenModal(true)}>
            Add visitor
          </Button>
        </Flex>
      </Flex>

      <CommonTable
        dataSource={filteredData}
        columns={columns}
        pagination={true}
        nextPage={handleNextPagination}
        prevPage={handlePrevPagination}
        scroll={{ y: 532, x: 1700 }}
        prevDisabled={page === 0 ? true : false}
        nextDisabled={visitorsList?.visitors?.length < 50 ? true : false}
      />
      <Modal
        title={editData ? `Edit visitor's details` : `Add visitor's details`}
        open={openModal}
        onCancel={() => setOpenModal(false)}
        onClose={() => setOpenModal(false)}
        onOk={() => form.submit()}
        okText="Submit"
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "please enter the name" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Contact number"
              name="contactNumber"
              rules={[
                { required: true, message: "please enter contact number" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="E mail"
              name="visitorMailId"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "please enter email",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Company name"
              name="companyName"
              rules={[{ required: true, message: "please enter company name" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="In time"
              name="inTime"
              rules={[{ required: true, message: "please enter in time" }]}
            >
              <TimePicker
                use12Hours
                format="h:mm a"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="Out time"
              name="outTime"
              rules={[{ required: true, message: "please enter out time" }]}
            >
              <TimePicker
                use12Hours
                format="h:mm a"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              label="Reference"
              name="referenceThrough"
              rules={[{ required: true, message: "please enter reference" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Purpose/Reason"
              name="purpose"
              rules={[
                { required: true, message: "please enter visitor's purpose" },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </CmGap>
  );
};

export default Visitors;
